/* eslint-disable */ 
//import _ from 'lodash'
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Tabs, Tab, Row, Col, Table } from 'react-bootstrap';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { DIVISIONS,TeamStandingsHeaders } from '../../../utils/constants';
import { teamStandingsFilter } from '../../../utils/functions';
import  Navwrapper  from '../../layout/Navigation';
import Footer from '../../layout/Footer';
import { getTeamStandingsBySeason } from '../api'
import { exportCSV, tableOptions} from '../common'

// type Myprops = {divID: number};
export default class TeamStandingsPage extends Component  {

  constructor(props) {
    super(props);
    const { match } = this.props
    this.state = {      
      teamStandings:[],
      seasonId:match.params.seasonId,
      eventId:match.params.eventId
    };
  }
  
  componentDidMount() {
    const _this = this
    getTeamStandingsBySeason(_this.state.seasonId,_this.state.eventId).then(function(response) {
       _this.setState({teamStandings: response.data}) 
   })
   }

   teamNameFormatter(cell, row, props ) {
    var link =  `/schoolAverage/${row.seasonId}/${row.eventId}/${row.teamId}/${props.match.params.eventName}/${props.match.params.seasonName}/${row.teamName}`
               + ( (row.division == 'M') ? '/true': '/false')+ ( (row.varsity == true) ? '/true': '/false');
     return (            
                 <Link className="cellLinksLeft" to={link}>{row.teamName}</Link>
           );        
  }        

   totalsRow(tabData) {
    
    var avgSum = tabData.reduce( function(cnt,i){ return cnt + i.avg; },0);    
    var itemCount = tabData.length;
    var eventFieldAvg = 0;
    if (itemCount > 0  ) {
      eventFieldAvg = parseFloat( ( avgSum / itemCount ).toFixed(3) );
    }
    var firstRow =tabData[0];
    var laneConditionRatio = '';
    var laneConditionType = '';
    var gamesBowled='';
    if (tabData.length > 0) {
        gamesBowled = firstRow.gamesBowled;
        if (firstRow.division == 'M') {
          laneConditionRatio = firstRow.laneConditionRatioMen + " : 1";
          laneConditionType = firstRow.laneConditionTypeMen;
        }
        else {
          laneConditionRatio = firstRow.laneConditionRatioWomen + "  : 1";
          laneConditionType = firstRow.laneConditionTypeWomen;
        }
    }
    return<Row >
            <Col xs={3} />
            <Col xs={6}>                                                
              <Table className="totals_table"  >
                <thead >
                  <tr >
                    <th/>
                    <th/>
                    <th/>
                    <th/>                                
                  </tr>
                </thead>
                <tbody>
                  <tr >
                    <td>Event Field Average:</td>
                    <td>{eventFieldAvg}</td>
                    <td>Lane Condition Ratio:</td>
                    <td>{laneConditionRatio}</td>
                  </tr>       

                  <tr >
                    <td>Lane Condition Type:</td>
                    <td>{laneConditionType}</td>                          
                    <td>Games Bowled:</td>
                    <td> {gamesBowled}</td>                          
                  </tr>                   
                </tbody>
              </Table>
            </Col>
          </Row>;
  }
  render() {
     const _this = this
     const { match } = this.props

     var eventName = match.params.eventName
     var seasonName = match.params.seasonName
     var teamStandingsMen = match.params.teamStandingsMen

      var defaultTab = 1;
      if (teamStandingsMen === 'false') {
        defaultTab = 2
      }

    const TeamStandings = this.state.teamStandings;
    const menVarsityTeamStandings = TeamStandings
      .filter( (teamStanding) => teamStandingsFilter( teamStanding, DIVISIONS.MEN, DIVISIONS.VARSITY)); 
    const womenVarsityTeamStandings = TeamStandings
      .filter( (teamStanding) => teamStandingsFilter( teamStanding, DIVISIONS.WOMEN, DIVISIONS.VARSITY)); 
    const menJVTeamStandings = TeamStandings
      .filter( (teamStanding) => teamStandingsFilter( teamStanding, DIVISIONS.MEN, DIVISIONS.JV)); 
    const womenJVTeamStandings = TeamStandings
      .filter( (teamStanding) => teamStandingsFilter( teamStanding, DIVISIONS.WOMEN, DIVISIONS.JV));     
    
    return (
      <div>
      <Navwrapper />
      <div className="container-fluid">
        <Row>
          <div className="pageHeading" >
              <h4>{seasonName}</h4>
              <h4></h4>
                <h4 >
                    {eventName}<br/>
                        Team Standings
                </h4>
          </div>
        </Row>      
        <Row>                 
          <Col xs={12} >                           
            <div className="rankingRightColumn_"> 
              <Tabs defaultActiveKey={ defaultTab }   id="team-standings-results-tabs">
                <Tab eventKey={1} title="VARSITY MEN">           
                      <BootstrapTable 
                        data={menVarsityTeamStandings} 
                        striped 
                        hover 
                        options={tableOptions}
                        pagination                 
                      >
                          <TableHeaderColumn          
                            dataField="Id" 
                            isKey  
                            dataAlign="right" 
                            dataSort  
                            data-Visible="false"               
                            hidden                  
                          >ID
                          </TableHeaderColumn>
                          <TableHeaderColumn dataField="no" dataSort  width="2%" >NO
                          </TableHeaderColumn>
                          <TableHeaderColumn 
                            dataField="teamName" 
                            dataSort   
                            dataFormat={this.teamNameFormatter}
                            formatExtraData={this.props} 
                            width="10%" 
                          >TEAM NAME
                          </TableHeaderColumn>   
                          <TableHeaderColumn dataField="teamS" dataAlign="right"  width="2%" >TEAM
                          </TableHeaderColumn>
                          <TableHeaderColumn dataField="bkr" dataAlign="right"  width="2%" >BKR
                          </TableHeaderColumn>
                          <TableHeaderColumn dataField="total" dataAlign="right"  width="2%" >TOTAL
                          </TableHeaderColumn>
                          <TableHeaderColumn dataField="gm" dataAlign="right"  width="2%" >GM
                          </TableHeaderColumn>
                          <TableHeaderColumn dataField="avg" dataAlign="right"  width="2%" >AVG
                          </TableHeaderColumn>
                          <TableHeaderColumn dataField="diff" dataAlign="right"  width="2%" >DIFF
                          </TableHeaderColumn>                  
                      </BootstrapTable>
                    
                      <Row className="blank_row" />
                        { exportCSV(menVarsityTeamStandings,TeamStandingsHeaders,'MenVarsityTeamStandings - '+ eventName +'.csv') }
                        {this.totalsRow(menVarsityTeamStandings)}
                  </Tab>
                <Tab eventKey={2} title="VARSITY WOMEN">
                      <BootstrapTable 
                        data={womenVarsityTeamStandings} 
                        striped  
                        hover  
                        options={tableOptions}
                        pagination   
                        // exportCSV             
                      >
                          <TableHeaderColumn          
                            dataField="Id" 
                            isKey  
                            dataAlign="right" 
                            dataSort  
                            data-Visible="false"               
                            hidden                  
                          >ID
                          </TableHeaderColumn>
                          <TableHeaderColumn dataField="no" dataSort  width="2%" >NO
                          </TableHeaderColumn>
                          <TableHeaderColumn 
                            dataField="teamName" 
                            dataSort   
                            dataFormat={this.teamNameFormatter} 
                            formatExtraData={this.props}
                            width="15%" 
                          >TEAM NAME
                          </TableHeaderColumn>   
                          <TableHeaderColumn dataField="teamS" dataAlign="right"  width="2%" >TEAM
                          </TableHeaderColumn>
                          <TableHeaderColumn dataField="bkr" dataAlign="right"  width="2%" >BKR
                          </TableHeaderColumn>
                          <TableHeaderColumn dataField="total" dataAlign="right"  width="2%" >TOTAL
                          </TableHeaderColumn>
                          <TableHeaderColumn dataField="gm" dataAlign="right"  width="2%" >GM
                          </TableHeaderColumn>
                          <TableHeaderColumn dataField="avg" dataAlign="right"  width="2%" >AVG
                          </TableHeaderColumn>
                          <TableHeaderColumn dataField="diff" dataAlign="right"  width="2%" >DIFF
                          </TableHeaderColumn>                  
                      </BootstrapTable>

                      <Row className="blank_row" />
                        { exportCSV(womenVarsityTeamStandings,TeamStandingsHeaders,'WomenVarsityTeamStandings - '+ eventName +'.csv') }
                        {this.totalsRow(womenVarsityTeamStandings)}
                </Tab>
                <Tab eventKey={3} title="JUNIOR VARSITY MEN">           
                      <BootstrapTable 
                        data={menJVTeamStandings} 
                        striped  
                        hover  
                        options={tableOptions}
                        pagination                
                      >
                          <TableHeaderColumn          
                            dataField="Id" 
                            isKey  
                            dataAlign="right" 
                            dataSort  
                            data-Visible="false"               
                            hidden                  
                          >ID
                          </TableHeaderColumn>
                          <TableHeaderColumn dataField="no" dataSort  width="2%" >NO
                          </TableHeaderColumn>
                          <TableHeaderColumn 
                            dataField="teamName" 
                            dataSort   
                            dataFormat={this.teamNameFormatter} 
                            formatExtraData={this.props}
                            width="10%" 
                          >TEAM NAME
                          </TableHeaderColumn>   
                          <TableHeaderColumn dataField="teamS" dataAlign="right"  width="2%" >TEAM
                          </TableHeaderColumn>
                          <TableHeaderColumn dataField="bkr" dataAlign="right"  width="2%" >BKR
                          </TableHeaderColumn>
                          <TableHeaderColumn dataField="total" dataAlign="right"  width="2%" >TOTAL
                          </TableHeaderColumn>
                          <TableHeaderColumn dataField="gm" dataAlign="right"  width="2%" >GM
                          </TableHeaderColumn>
                          <TableHeaderColumn dataField="avg" dataAlign="right"  width="2%" >AVG
                          </TableHeaderColumn>
                          <TableHeaderColumn dataField="diff" dataAlign="right"  width="2%" >DIFF
                          </TableHeaderColumn>                  
                      </BootstrapTable>
                    
                      <Row className="blank_row" />
                      { exportCSV(menJVTeamStandings,TeamStandingsHeaders,'MenJVTeamStandings - '+ eventName +'.csv') }
                      {this.totalsRow(menJVTeamStandings)}
                  </Tab>
                <Tab eventKey={4} title="JUNIOR VARSITY WOMEN">
                      <BootstrapTable 
                        data={womenJVTeamStandings} 
                        striped  
                        hover  
                        options={tableOptions}
                        pagination                
                      >
                          <TableHeaderColumn          
                            dataField="Id" 
                            isKey  
                            dataAlign="right" 
                            dataSort  
                            data-Visible="false"               
                            hidden                  
                          >ID
                          </TableHeaderColumn>
                          <TableHeaderColumn dataField="no" dataSort  width="2%" >NO
                          </TableHeaderColumn>
                          <TableHeaderColumn 
                            dataField="teamName" 
                            dataSort   
                            dataFormat={this.teamNameFormatter} 
                            formatExtraData={this.props}
                            width="15%" 
                          >TEAM NAME
                          </TableHeaderColumn>   
                          <TableHeaderColumn dataField="teamS" dataAlign="right"  width="2%" >TEAM
                          </TableHeaderColumn>
                          <TableHeaderColumn dataField="bkr" dataAlign="right"  width="2%" >BKR
                          </TableHeaderColumn>
                          <TableHeaderColumn dataField="total" dataAlign="right"  width="2%" >TOTAL
                          </TableHeaderColumn>
                          <TableHeaderColumn dataField="gm" dataAlign="right"  width="2%" >GM
                          </TableHeaderColumn>
                          <TableHeaderColumn dataField="avg" dataAlign="right"  width="2%" >AVG
                          </TableHeaderColumn>
                          <TableHeaderColumn dataField="diff" dataAlign="right"  width="2%" >DIFF
                          </TableHeaderColumn>                  
                      </BootstrapTable>

                      <Row className="blank_row" />
                        { exportCSV(womenJVTeamStandings,TeamStandingsHeaders,'WomenJVTeamStandings - '+ eventName +'.csv') }
                        {this.totalsRow(womenJVTeamStandings)}
                </Tab>
              </Tabs>
            </div>
          </Col>
        </Row>
        {/* <Row>
        <ToolkitProvider
          keyField="Id"
          data={ TeamStandings }
          columns={ columns }
          exportCSV
          >
            {
              props => (
                <div>
                  <ExportCSVButton { ...props.csvProps }>Export CSV!!</ExportCSVButton>
                  <hr />
                  <BootstrapTable { ...props.baseProps } />
                </div>
              )
            }
            </ToolkitProvider>          
        </Row> */}
      </div>
      <Footer />
    </div>

    );
  }
}


// WEBPACK FOOTER //
// ./src/components/pages/teamStandings/index.js